import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";

/**
 * 标签类型服务
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class TagTypeService extends ServiceBase {
    /**
     * 获取所有标签
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getTagList(data: any): Promise<IHttpResponse> {
        let response = await this.apis.getTagList({data});
        return response;
    }

    /**
     * 获取所有标签分页数据
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getTagPage(data: any): Promise<IHttpResponse> {
        let response = await this.apis.getTagPage({data});
        return response;
    }

    /**
     * 新增/编辑标签
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async operationTag(data: any): Promise<IHttpResponse> {
        let response;
        if(data.id)
        {
            response = await this.apis.editTag({ data });
        }else
        {
            response = await this.apis.addTag({ data });
        }

        return response;
    }

    /**
     * 删除标签
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async delTag(id: number): Promise<IHttpResponse> {
        let response = await this.apis.delTag({ urlPath: { id } });
        return response;
    }
}